var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overview-graph"},[(_vm.chartOptions)?_c('highcharts',{attrs:{"options":_vm.chartOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }